import { T_CONTACT_US_FORM_PAGE_CONSTANTS } from './TYPES'

const EN_CONTACT_US_FORM_PAGE_CONSTANTS: T_CONTACT_US_FORM_PAGE_CONSTANTS = {
  FULL_NAME_LABEL: 'Full Name',
  FULL_NAME_PLACEHOLDER: 'Enter your full name',
  FULL_NAME_ERRORS_REQUIRED: 'Full Name is required.',
  EMAIL_ID_LABEL: 'Email ID',
  EMAIL_ID_PLACEHOLDER: 'Enter your email ID',
  EMAIL_ID_ERRORS_REQUIRED: 'Email ID is required.',
  EMAIL_ID_ERRORS_INVALID: 'Enter a valid Email ID.',
  SUBJECT_LABEL: 'Subject',
  SUBJECT_PLACEHOLDER: 'Enter a subject',
  SUBJECT_ERRORS_REQUIRED: 'Subject is required.',
  MESSAGE_LABEL: 'Your Message',
  MESSAGE_PLACEHOLDER: 'Enter your message',
  MESSAGE_ERRORS_REQUIRED: 'Message is required.',
  SEND_CTA_TEXT: 'Send'
}

export default EN_CONTACT_US_FORM_PAGE_CONSTANTS
